import React from 'react';
import PropTypes from 'prop-types';

import { PostView } from 'features/blog/post/view';

import './view.scss';

export const ListView = ({ posts, startPage, endPage }) => (
    <section className="list">
        {
            posts.length ? posts.sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)).slice(startPage, endPage).map((currentValue, index) => (
                <PostView post={ currentValue } key={ index } />
            )) : <span>Brak wyników wyszukiwania...</span>
        }
    </section>
);

ListView.propTypes = {
    posts: PropTypes.instanceOf(Array).isRequired,
    startPage: PropTypes.string.isRequired,
    endPage: PropTypes.string.isRequired
};